import React, { Component } from 'react'
import styled from 'styled-components'

const Box = styled.div`
  background: var(--light-gray);
  height: 1px;
`

export default class Divider extends Component {
  render() {
    return <Box {...this.props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/Card/Divider.js